import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DadosAdicionaisModeloService } from '../services/dados-adicionais-modelo.service';


@Injectable({
  providedIn: 'root'
})
export class ListQuestionResolver implements Resolve<boolean> {

  constructor(private service: DadosAdicionaisModeloService) { }

  resolve(): Observable<any> {
    return this.service.listQuestion();
  }
}